import { ComponentRoute } from '@/classes'

const UserRoutes = {
  UserListView: new ComponentRoute('/users', 'UserListView'),
  UserView: new ComponentRoute('/users', 'UserView'),
  UserDetail: new ComponentRoute('/users/:userId', 'UserDetail'),
  UserProfile: new ComponentRoute('/userprofile/:userId', 'UserProfile'),
  UserAccessControl: new ComponentRoute('/accesscontrol/:userId', 'UserAccessControl'),
  UserAccessRestriction: new ComponentRoute('/accessrestriction/:userId', 'UserAccessRestriction')
}

export default UserRoutes
